import React from "react";
import { VisitInstanceId } from "../messages";
import { Visit } from "../system/AppState/AppVisitsState";
import { HashSet } from "../utils/HashSet";
import { CheckedVisitData } from "./AvailableVisitActivity";
import WithMultiShift from "./WithMultiShift";

interface Props {
  visit: Visit.Available;
  onClickRequest: (
    visitInstances: HashSet<VisitInstanceId>,
    checkedPatterns: HashSet<string>
  ) => void;
  onClickCancel: (visitInstances: VisitInstanceId[]) => void;
  children: (props: {
    onClickRequest: () => void;
    onClickCancel: () => void;
    checkedVisits: HashSet<VisitInstanceId>;
    checkedPatterns: HashSet<string>;
    areAllShiftsChecked: boolean;
    onCheckVisit: (visitData: CheckedVisitData) => void;
  }) => React.ReactNode;
}

export default function WithAvailableVisitMultiShift(props: Props) {
  return WithMultiShift<"AvailableVisit">(props);
}
